module.exports = "//s1.igetcool.com/mall-h5/img/huabeiCeng_icon.013e44f4.png";